import { Injectable } from '@angular/core';

export class AppConfig {
    [key: string]: AppConfig | string;
}

@Injectable({ providedIn: 'root' })
export class ApplicationConfiguration {
    configuration: AppConfig = {} as AppConfig;
}
